export default __webpack_public_path__ + "static/media/Micrah - Dark Electro (Full Version).2a0bc4b0.mp3";